import { invoiceModel } from '~/models';
const FULL_PAGE_KINDS = [
    'verificationRequired',
    'paid',
    'voided'
];
const isLocalConfirmation = (state)=>state.kind === 'confirmation';
const isLocalVoided = (state)=>state.kind === 'voided';
const isStillLoading = (input)=>input.state.kind !== 'ready' || input.isLoading || input.scoutInvoice == null || input.relationship == null;
const isVerificationRequired = (scoutInvoice)=>invoiceModel.isPaymentActionRequired(scoutInvoice);
const isInProgress = (scoutInvoice)=>invoiceModel.isPending(scoutInvoice) || invoiceModel.isProcessing(scoutInvoice) || invoiceModel.isConfirmed(scoutInvoice);
const isPaid = (scoutInvoice)=>invoiceModel.isPaid(scoutInvoice) || invoiceModel.isPaidExternally(scoutInvoice);
const isApproveForm = (scoutInvoice)=>invoiceModel.isPaymentFailed(scoutInvoice) || invoiceModel.isRequiresPaymentApproval(scoutInvoice);
const isFullPageInvoiceKind = (kind)=>FULL_PAGE_KINDS.includes(kind);
export const deriveDisplayState = (input)=>{
    const inner = deriveInnerDisplayState(input);
    return input.showFullPageInvoice && isFullPageInvoiceKind(inner.kind) ? {
        kind: 'fullPageInvoice'
    } : inner;
};
const deriveInnerDisplayState = (input)=>{
    const { state, scoutInvoice } = input;
    if (isLocalConfirmation(state)) return {
        kind: 'confirmation',
        amount: state.amount,
        vendorName: state.vendorName,
        animate: true
    };
    if (isLocalVoided(state)) return {
        kind: 'voided',
        amount: state.amount,
        vendorName: state.vendorName
    };
    if (isStillLoading(input) || scoutInvoice == null || state.kind !== 'ready') return {
        kind: 'loading'
    };
    const { amount, vendorName } = input;
    if (isVerificationRequired(scoutInvoice)) return {
        kind: 'verificationRequired',
        amount,
        vendorName
    };
    if (isInProgress(scoutInvoice)) return {
        kind: 'confirmation',
        amount,
        vendorName,
        animate: false
    };
    if (isPaid(scoutInvoice)) return {
        kind: 'paid',
        amount,
        vendorName
    };
    if (isApproveForm(scoutInvoice)) return {
        kind: 'approveForm'
    };
    // Catch-all for non-actionable statuses (refunded, disputed, stopped, ...) — render "no longer active".
    return {
        kind: 'voided',
        amount,
        vendorName
    };
};
